<template>
    <div :class="showMarBot ? 'bannerBottom' : ''">
        <el-carousel indicator-position="none" :height="bannerHeight">
            <el-carousel-item v-for="item in list" :key="item.id">
                <div @click="$openUrl(item.jump_url)" class="bannerItem">
                    <template v-if="item.type == 1">
                        <img class="itemImage" :src="item.url" alt="" />
                    </template>
                    <template v-else>
                        <video class="itemImage" :src="item.url" muted loop :ref="'video' + index"
                            :poster="item.url + '?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
                    </template>
                    <div class="textBox">
                        <div class="textCenter">
                            <div v-for="(item2, index2) in item.other.bigTitle" :key="index2" class="bigTitle">
                                {{ item2.title }}
                            </div>
                            <div v-for="(item2) in item.other.smallTitle" :key="item2.title" class="smallTitle">{{item2.title }}</div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        height: {
            type: String,
            default: '600px',
        },
        showMarBot: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            activeIndex: 0,
            locale: 'zh',
            list: [],
            bannerHeight: '600px',
        }
    },
    mounted() {
        this.locale = this.$i18n.locale;
        this.setHeight();
        window.addEventListener('resize', this.setHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setHeight);
    },
    methods: {
        setHeight() {
            const w = window.innerWidth || document.documentElement.clientWidth;
            this.bannerHeight = w <= 1200 ? (w * 0.56) + 'px' : this.height;
        },
        setList(e) {
            this.list = e;
        },
        goPlay() {
            let t = this;
            t.$refs['video' + t.activeIndex][0].play()
            t.$bus.$emit('overLoad')
        }
    }
}
</script>

<style scoped lang="scss">
.bannerBottom {
    margin-bottom: 116px;
}

.bannerItem {
    width: 100%;
    height: 100%;
    position: relative;

    .itemImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .textBox {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);

        .bigTitle {
            font-size: 40px;
            color: #FFFFFF;
            line-height: 60px;
            margin-bottom: 40px;
            text-align: center;
        }

        .smallTitle {
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
            margin-bottom: 26px;
            white-space: pre;
        }
    }
}

::v-deep .el-carousel__arrow--left {
    display: none !important;
}

::v-deep .el-carousel__arrow--right {
    display: none !important;
}

@media screen and (max-width:1200px) {
    .bannerItem {
        background: #000;

        .textBox {
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px;

            .bigTitle {
                font-size: 22px;
                line-height: 30px;
                margin-bottom: 20px;
            }

            .smallTitle {
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 14px;
                white-space: pre-wrap;
            }
        }
    }
}
</style>